/**
 * The registry contract: src/worlds/registry.ts globs `world.meta.ts` and reads the
 * NAMED export `meta`. `slug` must equal this directory's name or the registry reports
 * the world as unregistered rather than dropping it silently.
 */
export const meta = {
  id: "FW-22",
  name: "Verdance",
  slug: "verdance",
  title: "Verdance — a Fable World: health waitlist page",
  description:
    "An original health waitlist designed by Fable: an L-system vine that grows as you scroll, chartreuse on loam, a seat that unfurls."
} as const;

export type VerdanceMeta = typeof meta;
export default meta;
